import { PROPERTIES_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case PROPERTIES_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case PROPERTIES_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case PROPERTIES_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
